import { Checkbox, Col, Flex, Row } from "antd";
import ButtonComponent from "components/button/Button";
import InputComponent from "components/formInput/Input";
import Loading from "components/loading/Loading";
import PopupConfirm from "components/popup-confirm";
import TableComponent from "components/table/Table";
import {
  apiDeleteClinicById,
  apiExportCSVAllClinic,
  apiExportCSVClinic,
  apiGetListClinics,
} from "helpers/api/clinic";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE } from "routes/route";
import { showToastError, showToastSuccess } from "utils";
import "./styles.scss";

const AdminClinicsPage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchByProvince, setSearchByProvince] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [loading, setLoading] = useState(0);
  const [clinics, setClinics] = useState({
    data: [],
    page: 1,
    total_items: 0,
    total_page: 0,
  });

  const columns = [
    {
      title: t("clinic.hospital_name"),
      width: "20%",
      dataIndex: "clinic_name",
      align: "center",
      key: "clinic_name",
      render: (text, record) => (
        <div
          className="link-text"
          onClick={() =>
            history.push(ROUTE.ADMIN.CLINIC_EDIT.replace(":id", record.id))
          }
        >
          {text}
        </div>
      ),
    },
    {
      title: t("clinic.prefectures"),
      dataIndex: "address",
      align: "center",
      key: "address",
      render: (text) => {
        return `${text.province || ""}`;
      },
    },
    {
      title: t("clinic.address"),
      width: "20%",
      dataIndex: "address",
      align: "center",
      key: "address",
      render: (text) => {
        return `${text.province || ""} ${text.name || ""} ${text.building || ""
          }`;
      },
    },
    {
      title: t("clinic.phone"),
      dataIndex: "phone_number",
      align: "center",
      key: "phone",
    },
    {
      title: t("clinic.clinic_code"),
      dataIndex: "clinic_code",
      align: "center",
      key: "clinicCode",
    },
    {
      title: t("clinic.number_register"),
      width: "8%",
      dataIndex: "number_patient",
      align: "center",
      key: "numberRegister",
    },
  ];

  const getClinics = (newPage) => {
    setLoading((prev) => prev + 1);
    apiGetListClinics({
      page: newPage || clinics.page,
      limit: 15,
      key_search: searchInput,
      search_by_province: searchByProvince,
    })
      .then((res) => {
        if (res.error) {
          showToastError(res.error.message);
        } else {
          setClinics(res);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onRowClick = (record) => {
    console.log(record);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleExportCSVClinic = () => {
    if (selectedRowKeys.length > 0) {
      setLoading((prev) => prev + 1);
      apiExportCSVClinic({
        clinic_ids: selectedRowKeys,
      })
        .then((res) => {
          if (res.error) {
            showToastError("messages.MSG-USP025");
            setSelectedRowKeys([]);
          }
          if (res.data) {
            window.location.href = res.data;
            showToastSuccess("messages.MSG-USP024");
          }
        })
        .catch(({ error }) => {
          showToastError(`messages.${error.reason}`);
        })
        .finally(() => {
          setLoading((prev) => prev - 1);
          setSelectedRowKeys([]);
        });
    }
  };

  const handleExportAllClinic = () => {
    setLoading((prev) => prev + 1);
    apiExportCSVAllClinic()
      .then((res) => {
        if (res.error) {
          showToastError("messages.MSG-USP025");
        }
        if (res.data) {
          window.location.href = res.data;
          showToastSuccess("messages.MSG-USP024");
          setSelectedRowKeys([]);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
      });
  };

  const handleDeleteClinic = () => {
    setIsOpenDelete(false);
    setLoading((prev) => prev + 1);
    apiDeleteClinicById({
      clinic_ids: selectedRowKeys,
    })
      .then((res) => {
        if (res.error) {
          showToastError("messages.MSG-USP071");
          setSelectedRowKeys([]);
        }
        if (res.data) {
          showToastSuccess("messages.MSG-USP070");
          setSelectedRowKeys([]);
          getClinics(1);
        }
      })
      .catch(({ error }) => {
        showToastError(`messages.${error.reason}`);
      })
      .finally(() => {
        setLoading((prev) => prev - 1);
        setSelectedRowKeys([]);
      });
  };

  useEffect(() => {
    getClinics();
  }, []);

  return (
    <div className="main-content">
      <div className="root-right-header">
        <div className="screen-name">{t("clinic.clinic_title")}</div>
      </div>
      <div className="nav screen-title">{t("clinic.clinic_info")}</div>

      <div className="content">
        <Container>
          {/* SEARCH + TOTAL (trái)  |  EXPORT + DELETE (phải) */}
          <Row gutter={[16, 16]} align="middle" style={{ flexWrap: "wrap" }}>
            {/* Trái: ô tìm kiếm + tổng số */}
            <Col xs={24} md={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "16px",
                }}
              >
                <div style={{ maxWidth: "320px", width: "100%", flex: "0 1 320px" }}>
                  <InputComponent
                    suffix={
                      <img
                        src="/icons/search_img.png"
                        className="ic x2"
                        alt="icon-search"
                        onClick={() => getClinics(1)}
                      />
                    }
                    placeholder={t("clinic.search_placeholder")}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onEnter={() => getClinics(1)}
                  />
                </div>
                <span className="clinic-total-text">
                  {t("clinic.clinic_number")}：{clinics.data.length} {t("clinic.room")}
                </span>
              </div>
            </Col>

            {/* Phải: link export (trái) + nút 削除 (góc phải) */}
            <Col xs={24} md={12}>
              <div className="action-group">
                <div className="export-link-group">
                  <ButtonComponent
                    background="#11b5f6"
                    className="w-100-mobile"
                    text={t("clinic.export_option")}
                    onClick={handleExportCSVClinic}
                    disabled={selectedRowKeys.length === 0}
                  />
                  <ButtonComponent
                    background="#11b5f6"
                    className="w-100-mobile"
                    text={t("clinic.export_all")}
                    onClick={handleExportAllClinic}
                  />
                </div>
                <ButtonComponent
                  background="#fb5757"
                  className="w-100-mobile"
                  text={t("clinic.delete")}
                  onClick={() => setIsOpenDelete(true)}
                  disabled={selectedRowKeys.length === 0}
                />
              </div>
            </Col>
          </Row>

          {/* Checkbox */}
          <Row style={{ marginBottom: "10px" }}>
            <Col>
              <Checkbox
                name="patient_name"
                checked={searchByProvince}
                onChange={() => setSearchByProvince(!searchByProvince)}
              >
                <span style={{ fontWeight: 600 }}>{t("clinic.filter")}</span>
              </Checkbox>
            </Col>
          </Row>

          {/* Table */}
          <div className="responsive-table-wrapper">
            <TableComponent
              columns={columns}
              dataSource={clinics.data.map((item) => ({
                ...item,
                key: item.id,
              }))}
              rowSelection={rowSelection}
              pageSize={15}
              showPagination={false}
              showPage={false}
              onRow={onRowClick}
            />
          </div>

          {/* Pagination */}
          <Row
            style={{
              marginTop: "20px",
              justifyContent: "flex-end",
              padding: "0 20px",
            }}
          >
            <Col style={{ display: "flex", alignItems: "center" }}>
              {`${clinics.page}/${clinics.total_page} ${t("notices.page")}　`}
              <div style={{ display: "flex", gap: "10px" }}>
                {clinics.page > 1 && (
                  <span
                    style={{ cursor: "pointer", transform: "rotate(180deg)" }}
                    onClick={() => {
                      setClinics((prev) => ({ ...prev, page: prev.page - 1 }));
                      getClinics(clinics.page - 1);
                    }}
                  >
                    ▶
                  </span>
                )}
                {clinics.page < clinics.total_page && (
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setClinics((prev) => ({ ...prev, page: prev.page + 1 }));
                      getClinics(clinics.page + 1);
                    }}
                  >
                    ▶
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </Container>

        {/* Popup confirm */}
        <PopupConfirm
          open={isOpenDelete}
          onCancelText={t("button.cancel")}
          onOkText={t("button.delete")}
          content={t("confirm_delete")}
          onOk={() => handleDeleteClinic()}
          onCancel={() => setIsOpenDelete(false)}
          onOkColor="#FF3131"
        />

        {loading != 0 && <Loading />}
      </div>
    </div>
  );

};

export default AdminClinicsPage;
